import { Injectable } from '@angular/core';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject, ReplaySubject } from 'rxjs';
import { DialogComponent } from '../components/common/dialog/dialog.component';

@Injectable()
export class DialogService {

    public dlg_type_password: string = 'dlg_type_password';
    public dlg_type_loading: string = 'dlg_type_loading';
    public dlg_type_confirmation: string = 'dlg_type_confirmation';
    public dlg_type_prompt: string = 'dlg_type_prompt';
    public dlg_type_yes_no: string = 'dlg_type_yes_no';

    public dlg_response_yes: string = 'dlg_response_yes';
    public dlg_response_cancel: string = 'dlg_response_cancel';

    constructor(
        public ngbModal: NgbModal,
    ) { }


    public showLoadingDlg(dlgComponent, dlg_config): NgbModalRef {
        const modalRef = this.ngbModal.open(dlgComponent, { backdrop: 'static', keyboard: false });
        modalRef.componentInstance.data = {};
        modalRef.componentInstance.dlgType = this.dlg_type_loading;
        modalRef.componentInstance.dlg_config = dlg_config;
        return modalRef;
    }

    public showDialog(dlgComponent, dlg_type, dlg_config): NgbModalRef {
        const modalRef = this.ngbModal.open(dlgComponent, { backdrop: 'static', keyboard: false });
        modalRef.componentInstance.dlgType = dlg_type;
        modalRef.componentInstance.dlg_config = dlg_config;
        modalRef.componentInstance.msg_config = dlg_config;
        return modalRef;
    }

    public showYesNoDlg(dlgComponent, dlg_config): NgbModalRef {
        const modalRef = this.ngbModal.open(dlgComponent, { backdrop: 'static', keyboard: false });
        modalRef.componentInstance.data = {};
        modalRef.componentInstance.dlgType = this.dlg_type_yes_no;
        modalRef.componentInstance.dlg_config = dlg_config;
        return modalRef;
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/services/dialog.service.ts